import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { buildAvailabilityMap, formatDateKey, generateCalendarMatrix } from '@/utils/CalendarUtils';
import DayCell from '@/components/Calendar/DayCell';
import { ArrowBackIosNewOutlined, ArrowForwardIosOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const MonthCalendar = ({ year, month, availabilityData, onDayClick, onPrevMonth, onNextMonth }) => {
  const matrix = generateCalendarMatrix(year, month);
  const availabilityMap = buildAvailabilityMap(availabilityData);
  const { i18n } = useTranslation();

  const today = new Date();
  const todayKey = today.toISOString().slice(0, 10);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1, mt: 1 }}>
        <IconButton onClick={onPrevMonth}><ArrowBackIosNewOutlined fontSize="small" /></IconButton>

        <Typography variant="h6" sx={{ textTransform: 'capitalize' }}>
          {new Date(year, month, 1).toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })}
        </Typography>

        <IconButton onClick={onNextMonth}><ArrowForwardIosOutlined fontSize="small" /></IconButton>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="repeat(7, 1fr)" // 7 equal columns
        gap={0.5}
      >
        {matrix.flat().map((dateObj) => {
          const dateKey = formatDateKey(dateObj);
          const meta = availabilityMap[dateKey] || { available: 0, reserved: 0, barPosition: null };
          const isOutsideMonth = dateObj.getMonth() !== month;
          const isToday = dateKey === todayKey;

          return (
            <Box
              key={dateKey}
              sx={{
                width: '100%',
                minHeight: 60,
                display: 'flex',
              }}
            >
              <DayCell
                date={dateObj}
                availableCount={meta.available}
                reservedCount={meta.reserved}
                barPosition={meta.barPosition}
                isOutsideMonth={isOutsideMonth}
                isToday={isToday}
                onClick={() => onDayClick?.(dateObj, meta)}
              />
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default MonthCalendar;
